import { useLazyGetSearchTipiScommessaQuery } from 'features/api/sportApiSlice';
import {
  resetValueFilterSelectedTipiScommessa,
  setIndexFilterTipiScommessa,
  setValueFilterSelectedTipiScommessa,
} from 'features/sport/sportSlice';
import { useAppDispatch } from 'lib/centralStore';
import { useCallback, useEffect } from 'react';

export const useSportSearchTipiScommessa = (indexFilter: undefined | number, slug: string, debouncedValue: string) => {
  const [trigger, { currentData }] = useLazyGetSearchTipiScommessaQuery();
  const dispatch = useAppDispatch();

  const getSearchData = useCallback(async () => {
    if (debouncedValue?.trim().length >= 1) {
      await trigger({
        slug: slug!.replace(slug![0], ''),
        searchValue: debouncedValue,
      }).unwrap();
    }
  }, [slug, debouncedValue, trigger]);

  const unSubscribeSearch = useCallback(() => {
    trigger({ slug: slug!.replace(slug![0], ''), searchValue: debouncedValue }).abort();
    trigger({ slug: slug!.replace(slug![0], ''), searchValue: debouncedValue }).unsubscribe();
  }, [slug, debouncedValue, trigger]);

  useEffect(() => {
    dispatch(setIndexFilterTipiScommessa(undefined));
    if (debouncedValue?.trim().length >= 1) {
      getSearchData();
    }
    if (!debouncedValue || debouncedValue === '') {
      unSubscribeSearch();
    }
  }, [getSearchData, debouncedValue, dispatch, unSubscribeSearch]);

  useEffect(() => {
    if (indexFilter !== undefined) {
      dispatch(
        setValueFilterSelectedTipiScommessa({
          gruppoKey: currentData![indexFilter!]!.gruppoKey!,
          value: currentData![indexFilter!]!.descrizione!,
        })
      );
    } else {
      dispatch(resetValueFilterSelectedTipiScommessa(undefined));
    }
  }, [indexFilter]);
  return { getSearchData, currentData };
};
